/* Worldwide + easier RFQ contact/delivery section for BuyDirect & Save.
   - Country / Region dropdown (all countries) submitted as contact[Country]
   - Country-aware labels: State/ZIP for the US, Province/Postal elsewhere
   - State/Province becomes a dropdown for countries that have provinces (US, Canada, ...)
   - Province + postal optional for non-US so buyers in any country can submit
   - Phone accepts an international dialing code
   - Clearer optional markers + a "no payment" reassurance
   Small and self-contained; does NOT modify assets/rfq-form.js. */
(function(){
  function q(s,el){ return (el||document).querySelector(s); }
  function ensureMarker(lab, optional){
    var req=lab.querySelector(".rfq-req");
    var opt=lab.querySelector(".rfq-opt");
    if(optional){
      if(req){ req.parentNode.removeChild(req); }
      if(!opt){ opt=document.createElement("span"); opt.className="rfq-opt"; opt.textContent=" (optional)"; opt.style.cssText="font-weight:400;color:#8A909B;font-size:11.5px"; lab.appendChild(opt); }
    } else {
      if(opt){ opt.parentNode.removeChild(opt); }
      if(!req){ req=document.createElement("span"); req.className="rfq-req"; req.textContent="*"; lab.appendChild(req); }
    }
  }
  function setLabel(forId, text, optional){
    var lab=q('label[for="'+forId+'"]'); if(!lab) return;
    var first=lab.firstChild;
    if(first && first.nodeType===3){ first.nodeValue=text; }
    else { lab.insertBefore(document.createTextNode(text), lab.firstChild); }
    ensureMarker(lab, optional);
  }
  function replaceState(toSelect){
    var old=q("#state"); if(!old) return null;
    var isSelect = old.tagName==="SELECT";
    if(toSelect===isSelect) return old;
    var el = toSelect ? document.createElement("select") : document.createElement("input");
    if(!toSelect){ el.type="text"; }
    el.id="state"; el.name="state"; el.setAttribute("autocomplete","address-level1");
    old.parentNode.replaceChild(el, old);
    return el;
  }
  function applyCountry(){
    var sel=q("#country"); if(!sel) return;
    var opt=sel.options[sel.selectedIndex];
    var provinces=[];
    if(opt){ try{ provinces=JSON.parse(opt.getAttribute("data-provinces")||"[]"); }catch(e){ provinces=[]; } }
    var isUS = sel.value==="United States";
    var isCA = sel.value==="Canada";
    if(provinces.length){
      var s=replaceState(true);
      s.innerHTML="";
      var b=document.createElement("option"); b.value=""; b.textContent = isUS ? "Select state" : (isCA ? "Select province" : "Select region"); s.appendChild(b);
      provinces.forEach(function(p){ var o=document.createElement("option"); o.value=p[0]; o.textContent=p[0]; s.appendChild(o); });
      setLabel("state", isUS ? "State" : (isCA ? "Province" : "State / Province"), false);
    } else {
      var t=replaceState(false);
      t.removeAttribute("maxlength"); t.style.textTransform="none"; t.setAttribute("placeholder","Province / region (if any)");
      setLabel("state", "State / Province / Region", true);
    }
    var zip=q("#zip");
    if(zip){ zip.removeAttribute("maxlength"); zip.style.width="100%"; zip.setAttribute("placeholder", isUS ? "ZIP code" : "Postal code"); }
    setLabel("zip", isUS ? "ZIP code" : "Postal / postcode", !isUS);
  }
  function run(){
    if(!q("#addr")) return;
    var tags=q("#rfq-country-tags");
    var addrInput=q("#addr");
    if(tags && addrInput && !q("#country")){
      var addrField=addrInput.closest(".rfq-field");
      if(addrField){
        var field=document.createElement("div"); field.className="rfq-field";
        var lab=document.createElement("label"); lab.className="rfq-lab"; lab.setAttribute("for","country");
        lab.innerHTML='Country / Region<span class="rfq-req">*</span>';
        var sel=document.createElement("select"); sel.id="country"; sel.name="contact[Country]"; sel.setAttribute("autocomplete","country-name");
        sel.innerHTML=tags.innerHTML;
        field.appendChild(lab); field.appendChild(sel);
        addrField.parentNode.insertBefore(field, addrField);
        sel.addEventListener("change", applyCountry);
      }
    }
    var phone=q("#phone");
    if(phone){ phone.setAttribute("placeholder","Include country code, e.g. +1 555 123 4567"); phone.setAttribute("inputmode","tel"); }
    if(!q("#rfq-nopay")){
      var bar=q(".rfq-submit-note");
      if(bar){ var span=document.createElement("span"); span.id="rfq-nopay"; span.style.cssText="display:block;color:#0E7C61;font-weight:600;margin-bottom:4px"; span.textContent="No payment required — this is a quote request."; bar.insertBefore(span, bar.firstChild); }
    }
    applyCountry();
  }
  document.addEventListener("click", function(e){
    var t=e.target;
    if(t && (t.id==="reviewBtn" || (t.closest && t.closest("#reviewBtn")))){
      var country=(q("#country")||{}).value||"";
      if(country && country!=="United States"){
        var s=q("#state"), z=q("#zip");
        if(s && s.tagName==="INPUT" && !s.value.trim()) s.value="N/A";
        if(z && !z.value.trim()) z.value="N/A";
      }
    }
  }, true);
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded", run);
  else run();
})();